import { createSlice } from "@reduxjs/toolkit";
import { AcademicYearResponseDto } from "../../shared/dtos/academicYear/AcademicYearResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const academicYearSlice = createSlice({
  name: "academicYear",
  initialState: getInitialCrudState<AcademicYearResponseDto>(),
  reducers: { ...generateCrudReducers<AcademicYearResponseDto>() },
});

export const academicYearActions = academicYearSlice.actions;
export default academicYearSlice.reducer;
